

































import { Component, Emit, Mixins, Prop, PropSync, Watch } from 'vue-property-decorator'

import ModelSetter from '../../../../Mixins/ModelSetter'
import TextInput from '../../../Pi/fields/TextInput/TextInput.vue'

@Component({
  components: {
    TextInput,
  }
})
export default class CreateNewLabel extends Mixins(ModelSetter) {
  @PropSync('isOpen') modalIsOpen!: boolean

  @Prop() createLabel!: (label: string) => Promise<{ index: number }>

  @Prop() initName!: string

  @Emit()
  setLabel(id: number): { id:number } {
    return { id }
  }

  @Watch('modalIsOpen')
  modalIsOpenWatcher(val: boolean): void {
    if (val && this.initName) {
      this.label = this.initName
    }
  }

  isCreating = false

  label = ''

  onOk() {
    this.isCreating = true

    this.createLabel(this.label)
        .then(res => {
          this.setLabel(res.index)
          this.modalIsOpen = false
          this.label = ''
        })
        .finally(() => {
          this.isCreating = false
        })
  }
}
